import React, { Component } from 'react';
import {
    Wrapper,
    Container,
    Header,
    Div,
    Paragraph,
    FormWithChildren,
    DateTimePicker,
    TextInput,
    Select,
    TextArea,
    UserSearchInput,
    SignatureInput,
    ImageInput,
    Accordion,
} from 'library';

function get_form_elements() {
    var elements = [
        <Accordion
            index={10989}
            header={
                <div
                    className={'question-card'}
                    name={'10989_0'}
                    excel_reference={1}
                    style={{ fontSize: '24px' }}
                >
                    <Paragraph
                        text={'QUALITY CONTROL INSPECTION'}
                        style={{
                            margin: '0px',
                            fontSize: 'inherit',
                            marginRight: '200px',
                        }}
                    />
                </div>
            }
            names={'10990_0,10993_0,10994_0,10995_0'}
            sub_total={''}
            className={'col-12'}
            style={{ padding: '0px' }}
        >
            <Select
                className={'question-card'}
                name={'10990_0'}
                label={
                    'Select Position Below if QC Form is Completed by a Supervisor or Manager'
                }
                options={[
                    { text: 'Supervisor', value: 'Supervisor' },
                    { text: 'Area Supervisor', value: 'Area Supervisor' },
                    {
                        text: 'Dir/Mgr of Operations',
                        value: 'Dir/Mgr of Operations',
                    },
                    { text: 'Vice President', value: 'Vice President' },
                ]}
                radio={true}
                excel_reference={2}
            />
            <TextInput
                className={'question-card'}
                name={'10993_0'}
                label={'Area:'}
                excel_reference={5}
                required={true}
            />
            <TextInput
                className={'question-card'}
                name={'10994_0'}
                label={'Completed by:'}
                excel_reference={6}
                required={true}
            />
            <TextInput
                className={'question-card'}
                name={'10995_0'}
                label={'Supervisor'}
                excel_reference={7}
                required={true}
            />
        </Accordion>,

        <Accordion
            index={10996}
            header={
                <div
                    className={'question-card'}
                    name={'10996_0'}
                    excel_reference={8}
                    anchor={true}
                    anchor_text={'COMPACTOR ROOMS'}
                    style={{ fontSize: '24px' }}
                >
                    <Paragraph
                        text={'COMPACTOR ROOMS'}
                        style={{
                            margin: '0px',
                            fontSize: 'inherit',
                            marginRight: '200px',
                        }}
                    />
                </div>
            }
            names={'10997_0,10998_0,10999_0'}
            sub_total={'11011_0'}
            className={'col-12'}
            style={{ padding: '0px' }}
        >
            <Select
                className={'question-card'}
                name={'10997_0'}
                label={'Power Wash (ramp level)'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={9}
            />
            <Select
                className={'question-card'}
                name={'10998_0'}
                label={'Floors'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={10}
            />
            <Select
                className={'question-card'}
                name={'10999_0'}
                label={'Walls'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={11}
            />
            <TextInput
                className={'question-card'}
                name={'11008_0'}
                label={'COMMENTS '}
                excel_reference={20}
                fail_comment={true}
            />
            <div
                className={'question-card'}
                name={'11009_0'}
                excel_reference={21}
            >
                <Paragraph
                    text={'Take a photo'}
                    style={{ margin: '0px', fontSize: 'inherit' }}
                />
            </div>
            <ImageInput
                className={'question-card'}
                name={'11010_0'}
                excel_reference={22}
            />
            <TextInput
                className={'question-card'}
                name={'11011_0'}
                label={'Total Rating'}
                excel_reference={23}
                excel={'+Q9+Q10+Q11'}
            />
        </Accordion>,
        <Accordion
            index={11012}
            header={
                <div
                    className={'question-card'}
                    name={'11012_0'}
                    excel_reference={24}
                    anchor={true}
                    anchor_text={'TRITURATOR ROOMS'}
                    style={{ fontSize: '24px' }}
                >
                    <Paragraph
                        text={'TRITURATOR ROOMS'}
                        style={{
                            margin: '0px',
                            fontSize: 'inherit',
                            marginRight: '200px',
                        }}
                    />
                </div>
            }
            names={'11013_0,11014_0,11015_0'}
            sub_total={'11025_0'}
            className={'col-12'}
            style={{ padding: '0px' }}
        >
            <Select
                className={'question-card'}
                name={'11013_0'}
                label={'Power Wash Interior'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={25}
            />
            <Select
                className={'question-card'}
                name={'11014_0'}
                label={'Trash'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={26}
            />
            <Select
                className={'question-card'}
                name={'11015_0'}
                label={'Consumables Stocked'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={27}
            />
            <TextInput
                className={'question-card'}
                name={'11022_0'}
                label={'COMMENTS'}
                excel_reference={34}
                fail_comment={true}
            />
            <div
                className={'question-card'}
                name={'11023_0'}
                excel_reference={35}
            >
                <Paragraph
                    text={'Take a photo'}
                    style={{ margin: '0px', fontSize: 'inherit' }}
                />
            </div>
            <ImageInput
                className={'question-card'}
                name={'11024_0'}
                excel_reference={36}
            />
            <TextInput
                className={'question-card'}
                name={'11025_0'}
                label={'Total Rating'}
                excel_reference={37}
                excel={'Q25+Q26+Q27'}
            />
        </Accordion>,
        <Accordion
            index={11026}
            header={
                <div
                    className={'question-card'}
                    name={'11026_0'}
                    excel_reference={38}
                    anchor={true}
                    anchor_text={'TRASH ROOM'}
                    style={{ fontSize: '24px' }}
                >
                    <Paragraph
                        text={'TRASH ROOM'}
                        style={{
                            margin: '0px',
                            fontSize: 'inherit',
                            marginRight: '200px',
                        }}
                    />
                </div>
            }
            names={'11027_0,11028_0,11029_0'}
            sub_total={'11041_0'}
            className={'col-12'}
            style={{ padding: '0px' }}
        >
            <Select
                className={'question-card'}
                name={'11027_0'}
                label={'Power Wash Interior'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={39}
            />
            <Select
                className={'question-card'}
                name={'11028_0'}
                label={'Front/Back of Doors'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={40}
            />
            <Select
                className={'question-card'}
                name={'11029_0'}
                label={'Interior Walls'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={41}
            />
            <TextInput
                className={'question-card'}
                name={'11038_0'}
                label={'COMMENTS'}
                excel_reference={50}
                fail_comment={true}
            />
            <div
                className={'question-card'}
                name={'11039_0'}
                excel_reference={51}
            >
                <Paragraph
                    text={'Take a photo'}
                    style={{ margin: '0px', fontSize: 'inherit' }}
                />
            </div>
            <ImageInput
                className={'question-card'}
                name={'11040_0'}
                excel_reference={52}
            />
            <TextInput
                className={'question-card'}
                name={'11041_0'}
                label={'Total Rating'}
                excel_reference={53}
                excel={'Q39+Q40+Q41'}
            />
        </Accordion>,
        <Accordion
            index={11042}
            header={
                <div
                    className={'question-card'}
                    name={'11042_0'}
                    excel_reference={54}
                    anchor={true}
                    anchor_text={'LOADING DOCKS'}
                    style={{ fontSize: '24px' }}
                >
                    <Paragraph
                        text={'LOADING DOCKS'}
                        style={{
                            margin: '0px',
                            fontSize: 'inherit',
                            marginRight: '200px',
                        }}
                    />
                </div>
            }
            names={'11043_0'}
            sub_total={'11056_0'}
            className={'col-12'}
            style={{ padding: '0px' }}
        >
            <Select
                className={'question-card'}
                name={'11043_0'}
                label={'Floors'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={55}
            />
            <TextInput
                className={'question-card'}
                name={'11053_0'}
                label={'COMMENTS'}
                excel_reference={65}
                fail_comment={true}
            />
            <div
                className={'question-card'}
                name={'11054_0'}
                excel_reference={66}
            >
                <Paragraph
                    text={'Take a photo'}
                    style={{ margin: '0px', fontSize: 'inherit' }}
                />
            </div>
            <ImageInput
                className={'question-card'}
                name={'11055_0'}
                excel_reference={67}
            />
            <TextInput
                className={'question-card'}
                name={'11056_0'}
                label={'Total Rating '}
                excel_reference={68}
                excel={'Q55'}
            />
        </Accordion>,
        <Accordion
            index={11057}
            header={
                <div
                    className={'question-card'}
                    name={'11057_0'}
                    excel_reference={69}
                    anchor={true}
                    anchor_text={'GENERAL'}
                    style={{ fontSize: '24px' }}
                >
                    <Paragraph
                        text={'GENERAL'}
                        style={{
                            margin: '0px',
                            fontSize: 'inherit',
                            marginRight: '200px',
                        }}
                    />
                </div>
            }
            names={'11058_0,11059_0,11060_0,11061_0'}
            sub_total={'11068_0'}
            className={'col-12'}
            style={{ padding: '0px' }}
        >
            <Select
                className={'question-card'}
                name={'11058_0'}
                label={'Trash/Recycling Pileups'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={70}
            />
            <Select
                className={'question-card'}
                name={'11059_0'}
                label={'Smoking Areas'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={71}
            />
            <Select
                className={'question-card'}
                name={'11060_0'}
                label={'Report large bulky items to Den'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={72}
            />
            <Select
                className={'question-card'}
                name={'11061_0'}
                label={'Removal of Pallets'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={73}
            />
            <TextInput
                className={'question-card'}
                name={'11065_0'}
                label={'COMMENTS'}
                excel_reference={77}
                fail_comment={true}
            />
            <div
                className={'question-card'}
                name={'11066_0'}
                excel_reference={78}
            >
                <Paragraph
                    text={'Take a Photo'}
                    style={{ margin: '0px', fontSize: 'inherit' }}
                />
            </div>
            <ImageInput
                className={'question-card'}
                name={'11067_0'}
                excel_reference={79}
            />
            <TextInput
                className={'question-card'}
                name={'11068_0'}
                label={'Total Rating'}
                excel_reference={80}
                excel={'Q70+Q71+Q72+Q73'}
            />
        </Accordion>,

        <Accordion
            index={11069}
            header={
                <div
                    className={'question-card'}
                    name={'11069_0'}
                    excel_reference={81}
                    anchor={true}
                    anchor_text={'JANITOR CLOSET / STORAGE AREA'}
                    style={{ fontSize: '24px' }}
                >
                    <Paragraph
                        text={'JANITOR CLOSET / STORAGE AREA'}
                        style={{
                            margin: '0px',
                            fontSize: 'inherit',
                            marginRight: '200px',
                        }}
                    />
                </div>
            }
            names={'11070_0,11071_0,11072_0,11073_0,11530_0,11531_0'}
            sub_total={'11077_0'}
            className={'col-12'}
            style={{ padding: '0px' }}
        >
            <Select
                className={'question-card'}
                name={'11070_0'}
                label={'Mop Sink & Floors'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={82}
            />
            <Select
                className={'question-card'}
                name={'11071_0'}
                label={'Supplies/Equipment (Stored neat & orderly)'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={83}
            />
            <Select
                className={'question-card'}
                name={'11072_0'}
                label={'SDS binders in closet and chemicals labeled'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={84}
            />
            <Select
                className={'question-card'}
                name={'11073_0'}
                label={'All chemicals in the closet are approved'}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={85}
            />
            <Select
                className={'question-card'}
                name={'11530_0'}
                label={'Have all checklists been completed? '}
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={86}
            />
            <Select
                className={'question-card'}
                name={'11531_0'}
                label={
                    'Have all employees completed the sign in/out sheet for their shift?  '
                }
                options={[
                    { text: 'Pass', value: 1 },
                    { text: 'Fail', value: 0 },
                ]}
                radio={true}
                excel_reference={87}
            />
            <TextInput
                className={'question-card'}
                name={'11074_0'}
                label={'COMMENTS'}
                excel_reference={88}
                fail_comment={true}
            />
            <div
                className={'question-card'}
                name={'11075_0'}
                excel_reference={89}
            >
                <Paragraph
                    text={'Take a photo'}
                    style={{ margin: '0px', fontSize: 'inherit' }}
                />
            </div>
            <ImageInput
                className={'question-card'}
                name={'11076_0'}
                excel_reference={90}
            />
            <TextInput
                className={'question-card'}
                name={'11077_0'}
                label={'Rating Total'}
                excel_reference={91}
                excel={'Q82+Q83+Q84+Q85+Q86+Q87'}
            />
        </Accordion>,
        <Accordion
            index={11080}
            header={
                <div
                    className={'question-card'}
                    name={'11080_0'}
                    excel_reference={94}
                    anchor={true}
                    anchor_text={'CAN WE PROVIDE ADDITIONAL SERV'}
                    style={{ fontSize: '24px' }}
                >
                    <Paragraph
                        text={
                            'CAN WE PROVIDE ADDITIONAL SERVICES (TAGS)?  What extra services can we suggest to make the buildings look better?'
                        }
                        style={{
                            margin: '0px',
                            fontSize: 'inherit',
                            marginRight: '200px',
                        }}
                    />
                </div>
            }
            names={'11081_0,11082_0,11083_0,11084_0,11085_0,11086_0'}
            sub_total={''}
            className={'col-12'}
            style={{ padding: '0px' }}
        >
            <Select
                className={'question-card'}
                name={'11081_0'}
                label={'Do any areas need pressure washing? '}
                options={[
                    { text: 'Yes', value: 'Yes' },
                    { text: 'No', value: 'No' },
                ]}
                radio={true}
                excel_reference={95}
            />
            <Select
                className={'question-card'}
                name={'11082_0'}
                label={'Do we need to shampoo carpet before periodics are due?'}
                options={[
                    { text: 'Yes', value: 'Yes' },
                    { text: 'No', value: 'No' },
                ]}
                radio={true}
                excel_reference={96}
            />
            <Select
                className={'question-card'}
                name={'11083_0'}
                label={
                    'Do we need to strip & wax floor before periodics are due?'
                }
                options={[
                    { text: 'Yes', value: 'Yes' },
                    { text: 'No', value: 'No' },
                ]}
                radio={true}
                excel_reference={97}
            />
            <Select
                className={'question-card'}
                name={'11084_0'}
                label={'Do we need to provide any exterior window cleaning?'}
                options={[
                    { text: 'Yes', value: 'Yes' },
                    { text: 'No', value: 'No' },
                ]}
                radio={true}
                excel_reference={98}
            />
            <Select
                className={'question-card'}
                name={'11085_0'}
                label={'Can we provide a maintenance technician?'}
                options={[
                    { text: 'Yes', value: 'Yes' },
                    { text: 'No', value: 'No' },
                ]}
                radio={true}
                excel_reference={99}
            />
            <TextInput
                className={'question-card'}
                name={'11086_0'}
                label={
                    'If the answer to a question above is yes please comment below'
                }
                excel_reference={100}
            />
        </Accordion>,
        <TextInput
            className={'question-card'}
            name={'11078_0'}
            label={'Grand Total'}
            excel_reference={92}
            anchor={true}
            anchor_text={'Grand Total'}
            excel={'Q23+Q37+Q53+Q68+Q80+Q91'}
        />,
        <TextInput
            className={'question-card'}
            name={'11079_0'}
            label={'Percentage'}
            excel_reference={93}
            excel={'(Q92/20)*100'}
        />,
    ];

    return elements;
}

export default get_form_elements;
